import { track, EventTypes, getPageSource } from '@mc/track-event'

/**
 * Track when users click on the row in Certificates row
 */
export const trackCertificateRowClick = ({
  source,
}: {
  source: 'icon' | 'link'
}) =>
  track(EventTypes.PLANS_PAGE_CLICK, {
    category: 'pricing matrix',
    action:
      source === 'icon' ? 'certificates.tooltip' : 'certificates.learnmore',
    location: 'General',
  })

export const trackFaqLinkClick = ({ action }: { action: string }) =>
  track(EventTypes.PLANS_PAGE_CLICK, {
    category: 'faq',
    location: 'General',
    action,
    subscription_id: {},
    active_annual_pass: false,
    page_path: window.location.pathname,
    page_source: getPageSource(),
  })
